<template>
    <div id="sites-page">
        <ToolbarComponent :title="$t('sites_page.title')" />

        <div class="pa-4">
            <p class="font-weight-bold">{{ $tc('sites_page.total_sites', sites.length) }}</p>

            <v-data-table
                :headers="headers"
                :items="sites"
                :loading="fetching_sites"
                class="stripe-date-table"
                disable-sort
                item-key="id_domicile"
            >
                <template v-slot:item.address="{ item }">
                    <span>{{ `${item.address}, ${item.postal_code} ${item.city}, ${item.country}` }}</span>
                </template>

                <template v-slot:item.actions="{ item }">
                    <MenuActionsComponent
                        :actions="[
                            {
                                title: $t('sites_page.see_details'),
                                icon: 'mdi-eye',
                                emit: 'seeSiteDetails',
                                has_access: true,
                            },
                        ]"
                        v-on:seeSiteDetails="seeSiteDetails(item)"
                    />
                </template>
            </v-data-table>

            <div class="bottom-hidden-div" />
        </div>
    </div>
</template>

<script>
import ToolbarComponent from '@/components/global/ToolbarComponent'
import MenuActionsComponent from '@/components/global/containment/MenuActionsComponent.vue'

export default {
    name: 'SitesPage',
    components: {
        ToolbarComponent,
        MenuActionsComponent,
    },
    data() {
        return {
            fetching_sites: true,
            sites: [],
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t('sites_page.name'), value: 'address_name' },
                { text: this.$t('global.address'), value: 'address' },
                { text: this.$t('global.actions'), value: 'actions' },
            ]
        },

        suicleanModule() {
            return this.$store.getters['asset_module/asset_modules'].find((asset_module) => asset_module.designation === 'GNC_SCLN')
        },
    },
    watch: {
        suicleanModule() {
            this.fetchSuicleanSites()
        },
    },
    methods: {
        seeSiteDetails(site) {
            this.$router.push({ name: 'site_details', params: { id: site.id_domicile } })
        },

        async fetchSuicleanSites() {
            if (this.suicleanModule) {
                this.fetching_sites = true
                await this.$store.dispatch('asset_module/fetchAssetsOfAssetModule', this.suicleanModule.id_module)

                const assets = this.$store.getters['asset_module/assets_by_asset_module'](this.suicleanModule.id_module)
                this.sites = [
                    ...new Map(
                        assets.filter((asset) => asset.domicile).map((asset) => [asset.domicile.id_domicile, asset.domicile])
                    ).values(),
                ]
            }

            this.fetching_sites = false
        },
    },
    created() {
        this.fetchSuicleanSites()
    },
}
</script>
